// src/pages/Cart.jsx
import React from "react";
import { useCart } from "../context/CartContext";
import { useNavigate } from "react-router-dom";
import { IMAGE_URL } from "../api/api";
import "../styles/Cart.css";

export default function Cart({ userId }) {
  const { cart, loading, updateQuantity, removeFromCart } = useCart();
  const navigate = useNavigate();

  if (!userId) {
    return (
      <div className="empty-cart">
        <p>Please log in to view your cart.</p>
        <button className="cart-btn" onClick={() => navigate("/login")}>Login</button>
      </div>
    );
  }

  if (loading) return <p>Loading cart…</p>;

  if (cart.length === 0) {
    return (
      <div className="empty-cart">
        <p>Your cart is empty.</p>
        <button className="cart-btn" onClick={() => navigate("/menu")}>Order Now</button>
      </div>
    );
  }

  return (
    <div className="cart-container">
      <h2>Your Cart</h2>
      <ul className="cart-list">
        {cart.map(item => (
          <li key={item.id} className="cart-item">
            <img
              src={`${IMAGE_URL}${item.image}`}
              alt={item.name}
            />
            <div className="cart-info">
              <h3>{item.name}</h3>
              <p>₹{Number(item.price).toFixed(2)}</p>
              <div className="quantity-controls">
                <button onClick={() => updateQuantity(item.food_id || item.id, parseInt(item.quantity) - 1)}>–</button>
                <span>{item.quantity}</span>
                <button onClick={() => updateQuantity(item.food_id || item.id, parseInt(item.quantity) + 1)}>+</button>
              </div>
            </div>
            <button className="remove-btn" onClick={() => removeFromCart(item.food_id || item.id)}>
              Remove
            </button>
          </li>
        ))}
      </ul>
      <div className="cart-actions">
        <button className="checkout-btn" onClick={() => navigate("/payment")}>
          Proceed to Checkout
        </button>
      </div>
    </div>
  );
}
